import { motion, AnimatePresence } from "framer-motion";
import { GrFormEdit } from "react-icons/gr";
import anonymous from "../../../assets/images/anonymous.jpg";
import ProfileCargoService from "../../../services/ProfileCargo";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../redux/slices/toastSlice";
import { useRef } from "react";
import FileService from "../../../services/file";
import CargoService from "../../../services/Cargo";
import { FiLock } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import DashboardSkeleton from "../../rent/dashboard/dashboard/DashboardSkeleton";


export default function DashboardContent() {
  const dispatch = useDispatch()
  const [prof, setProf] = useState({});
  const [mobile, setMobile] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [ncode, setNcode] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [errors, setErrors] = useState({});
  const [isChanged, setIsChanged] = useState(false);

  // upload image
  const [uploading, setUploading] = useState(false);
  const [profileImg, setProfileImg] = useState(null);
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);

  async function uploadProfileImage(file) {

    if (!file) return;
    try {
      setUploading(true);


      const formData = new FormData();
      formData.append("file", file);

      const res1 = await FileService.uploadFile(formData);
      const res = await CargoService.updateImage({ imageId: res1?.data?.message?._id })

      if (res?.status === 200) {
        dispatch(showToast({ message: "تصویر پروفایل با موفقیت آپلود شد", type: "success" }));
        setProfileImg(URL.createObjectURL(file));
      }
    } catch (err) {
      dispatch(showToast({ message: "خطا در آپلود تصویر", type: "error" }));
      console.error(err);
    } finally {
      setUploading(false);
    }
  }




  function validate() {
    const errs = {};

    if (fname.trim().length < 3) errs.fname = "نام باید حداقل 3 کاراکتر باشد";
    if (lname.trim().length < 3) errs.lname = "نام خانوادگی باید حداقل 3 کاراکتر باشد";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }


  function prepareForApi(input) {

    let digits = input.replace(/\D/g, "");


    if (digits.startsWith("0")) {
      digits = digits.slice(1);
    }

    return digits;
  }

  async function updateDashboard(e) {
    e.preventDefault();
    if (!validate()) return;
    try {
      setLoadingBtn(true);
      const body = { mobile: prepareForApi(mobile), firstname: fname, lastname: lname, national_code: ncode };
      const res = await ProfileCargoService.updateProfile(body);
      setProf(res?.data?.data);
      setIsChanged(false);
      if (res?.status === 200) {
        dispatch(showToast({ message: "اطلاعات با موفقیت بروزرسانی شد", type: "success" }))
        await getMyProfile()
      }
    } catch (err) {

      dispatch(showToast({ message: "خطا در تغییر اطلاعات", type: "error" }))

      console.log(err);
    } finally {
      setLoadingBtn(false);
    }
  }

  async function getMyProfile() {
    setLoading(true);
    try {
      const res = await ProfileCargoService.getMyProfile();
      console.log(res)
      const data = res?.data?.data?.finduser;
      setProf(data);
      setMobile("0" + data?.mobile || "");
      setProfileImg(data?.imageId?.path ? `https://barsaraa.maksiran.ir${data?.imageId?.path}` : null)
      setFname(data?.firstname || "");
      setLname(data?.lastname || "");
      setNcode(data?.national_code || "");
    } catch (err) {
      console.log(err);
    }
    finally {
      setLoading(false);
    }
  }

  console.log(prof)
  useEffect(() => { getMyProfile(); }, []);


  useEffect(() => {
    if (
      fname !== (prof?.firstname || "") ||
      lname !== (prof?.lastname || "") ||
      mobile !== ("0" + prof?.mobile || "") ||
      ncode !== (prof?.national_code || "")
    ) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [fname, lname, mobile, ncode, prof]);

  const shakeAnimation = { x: [0, -6, 6, -6, 6, 0], transition: { duration: 0.4 } };

  if (loading) return <DashboardSkeleton />;

  return (
    <div className="flex flex-col items-center w-full max-w-[360px]">

      <div className="relative">

        <motion.img
          src={profileImg != null ? profileImg : anonymous}

          className={`${uploading && "animate-pulse"} w-32 h-32 rounded-full border-[3px] border-special p-[3px] shadow object-cover`}
          transition={uploading ? { repeat: Infinity, duration: 1 } : {}}
        />

        {/*<motion.img*/}
        {/*src={profileImg}*/}
        {/*alt="پروفایل"*/}
        {/*className={`${uploading && "animate-pulse" } w-32 h-32 rounded-full border-[3px] border-special p-[3px] shadow object-cover`}*/}

        {/*transition={uploading ? { repeat: Infinity, duration: 1 } : {}}*/}
        {/*/>*/}
        <button
          type="button"
          onClick={() => fileInputRef.current.click()}
          className="flex items-center justify-center w-[29px] h-[29px] absolute bottom-1 right-2 bg-special text-white rounded-full "
        >
          <GrFormEdit size={20} />
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => uploadProfileImage(e.target.files[0])}
        />
      </div>

      <span className="mt-4 text-gray-500 font-medium">0{prof?.mobile || "-"}</span>

      <form className="mt-12 w-full flex flex-col gap-3" onSubmit={updateDashboard}>

        <div className="relative">
          <motion.input
            type="text"
            value={fname}
            onChange={(e) => {
              setFname(e.target.value)
              if (errors.fname) {
                setErrors((prev) => ({ ...prev, fname: undefined }))
              }
            }}
            className={`w-full rounded-xl border ${errors.fname ? "border-red-500" : "border-gray-500"} bg-gray-100 py-3 pr-5 pl-4 focus:outline-none`}
            placeholder="نام"
            animate={errors.fname ? shakeAnimation : {}}
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-special"><GrFormEdit size={20} /></span>
          {errors.fname && <p className="text-red-500 text-sm mt-1">{errors.fname}</p>}
        </div>


        <div className="relative">
          <motion.input
            type="text"
            value={lname}
            onChange={(e) => {
              setLname(e.target.value)
              if (errors.lname) {
                setErrors((prev) => ({ ...prev, lname: undefined }))
              }
            }}
            className={`w-full rounded-xl border ${errors.lname ? "border-red-500" : "border-gray-500"} bg-gray-100 py-3 pr-5 pl-4 focus:outline-none`}
            placeholder="نام خانوادگی"
            animate={errors.lname ? shakeAnimation : {}}
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-special"><GrFormEdit size={20} /></span>
          {errors.lname && <p className="text-red-500 text-sm mt-1">{errors.lname}</p>}
        </div>

        <div className="relative">
          <motion.input
            type="text"
            value={mobile}
            onChange={(e) => {
              setMobile(e.target.value)
              if (errors.mobile) {
                setErrors((prev) => ({ ...prev, mobile: undefined }))
              }
            }}
            readOnly
            className={`w-full rounded-xl border ${errors.mobile ? "border-red-500" : "border-gray-500"} bg-gray-100 py-3 pr-5 pl-4 focus:outline-none`}
            placeholder="موبایل"

            animate={errors.mobile ? shakeAnimation : {}}
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-special"><FiLock size={20} /></span>
          {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>}
        </div>

        <div className="relative">
          <motion.input
            type="text"
            value={ncode}
            onChange={(e) => {
              setNcode(e.target.value)
              if (errors.national_code) {
                setErrors((prev) => ({ ...prev, national_code: undefined }))
              }
            }}
            readOnly
            className={`w-full rounded-xl border ${errors.ncode ? "border-red-500" : "border-gray-500"} bg-gray-100 py-3 pr-5 pl-4 focus:outline-none`}
            placeholder="کد ملی"
            animate={errors.ncode ? shakeAnimation : {}}
          />
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-special"><FiLock size={20} /></span>
          {errors.ncode && <p className="text-red-500 text-sm mt-1">{errors.ncode}</p>}
        </div>


        <AnimatePresence>
          {isChanged && (
            <motion.button
              key="submit-btn"
              type="submit"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
              className={`${loadingBtn ? "opacity-70" : "opacity-100"} mt-10 bg-special text-white hover:bg-white hover:text-special border border-special transition-colors duration-300 rounded-xl py-3`}
            >
              {loadingBtn ? "منتظر بمانید..." : "ثبت تغییرات"}
            </motion.button>
          )}
        </AnimatePresence>
      </form>
    </div>
  );
}
